export default "__VITE_ASSET__BSxX4Zld__"